import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-beyond-create',
  templateUrl: './beyond-create.component.html',
  styleUrls: ['./beyond-create.component.scss']
})
export class BeyondCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  coursename = null;
  submitted = false;
  public feesForm: FormGroup;
  public courses = [];
  public editorContent: string = '';

  public editorConfig = {
    allowedContent: true, // disables filtering, keeps styles
    //extraAllowedContent: 'p(style);div(style);img(style); h1(style); h2(style); h3(style);h4(style); h5(style); h6(style); span(style);', // allows styles on specific tags
    extraAllowedContent: '*[style];',
  };
  /* public addinputs: any[] = [{
    dtution: '',
    dacademic: '',
    dtotal: '',
    itution: '',
    iacademic: '',
    itotal: '',
  }];

  addAddress() {
    this.addinputs.push({
      dtution: '',
      dacademic: '',
      dtotal: '',
      itution: '',
      iacademic: '',
      itotal: '',
    });
  }

  removeAddress(i: number) {
    this.addinputs.splice(i, 1);
  } */

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];

      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint + '/beyond/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if (data.data != null) {
            this.action = 'Update';
            this.feesForm.patchValue({
              _id: data.data._id,
              courseId: data.data.courseId,
              coursename: data.data.coursename,
              slider_title: data.data.slider_title,
              slider_desc: data.data.slider_desc,
              brouhure_url: data.data.brouhure_url,
              apply_url: data.data.apply_url,
              slider_img: data.data.slider_img,
              slider_alt_image: data.data.slider_alt_image,
              title1: data.data.title1,
              title1_desc: data.data.title1_desc,
              title2: data.data.title2,
              title2_img1: data.data.title2_img1,
              title2_img1_alt: data.data.title2_img1_alt,
              title2_img2: data.data.title2_img2,
              title2_img2_alt: data.data.title2_img2_alt,
              title2_img3: data.data.title2_img3,
              title2_img3_alt: data.data.title2_img3_alt,
              skill1: data.data.skill1,
              skill1_desc: data.data.skill1_desc,
              skill2: data.data.skill2,
              skill2_desc: data.data.skill2_desc,
              skill3: data.data.skill3,
              skill3_desc: data.data.skill3_desc,
              imp_btn1_text: data.data.imp_btn1_text,
              imp_btn1_url: data.data.imp_btn1_url,
              title3: data.data.title3,
              title3_desc: data.data.title3_desc,
              title3_img1: data.data.title3_img1,
              title3_img1_alt: data.data.title3_img1_alt,
              title3_img2: data.data.title3_img2,
              title3_img2_alt: data.data.title3_desc,
              title3_img3: data.data.title3_img1,
              title3_img3_alt: data.data.title3_img1_alt,
              skill4: data.data.skill4,
              skill4_desc: data.data.skill4_desc,
              skill5: data.data.skill5,
              skill5_desc: data.data.skill5_desc,
              skill6: data.data.skill6,
              skill6_desc: data.data.skill6_desc,
              imp_btn2_text: data.data.imp_btn2_text,
              imp_btn2_url: data.data.imp_btn2_url,
              title4: data.data.title4,
              count1: data.data.count1,
              count1_desc: data.data.count1_desc,
              count1_title: data.data.count1_title,
              count1_keys: data.data.count1_keys,
              count2: data.data.count2,
              count2_desc: data.data.count2_desc,
              count2_title: data.data.count2_title,
              count2_keys: data.data.count2_keys,
              title5: data.data.title5,
              title5_desc: data.data.title5_desc,
              title5_img1: data.data.title5_img1,
              title5_img1_alt: data.data.title5_img1_alt,
              title5_img2: data.data.title5_img2,
              title5_img2_alt: data.data.title5_img2_alt,
              title5_img3: data.data.title5_img3,
              title5_img3_alt: data.data.title5_img3_alt,
              skill7: data.data.skill7,
              skill7_desc: data.data.skill7_desc,
              skill8: data.data.skill8,
              skill8_desc: data.data.skill8_desc,
              skill9: data.data.skill9,
              skill9_desc: data.data.skill9_desc,
              imp_btn3_text: data.data.imp_btn3_text,
              imp_btn3_url: data.data.imp_btn3_url,
              title6: data.data.title6,
              skill10: data.data.skill10,
              skill10_desc: data.data.skill10_desc,
              skill10_keys: data.data.skill10_keys,
              skill11: data.data.skill11,
              skill11_desc: data.data.skill11_desc,
              skill11_keys: data.data.skill11_keys,
              skill12: data.data.skill12,
              skill12_desc: data.data.skill12_desc,
              skill12_keys: data.data.skill12_keys,
              title7: data.data.title7,
              title7_img1: data.data.title7_img1,
              title7_img1_alt: data.data.title7_img1_alt,
              title7_img2: data.data.title7_img2,
              title7_img2_alt: data.data.title7_img2_alt,
              title7_img3: data.data.title7_img3,
              title7_img3_alt: data.data.title7_img3_alt,
              skill13: data.data.skill13,
              skill13_desc: data.data.skill13_desc,
              skill14: data.data.skill14,
              skill14_desc: data.data.skill14_desc,
              skill15: data.data.skill15,
              skill15_desc: data.data.skill15_desc,
              imp_btn4_text: data.data.imp_btn4_text,
              imp_btn4_url: data.data.imp_btn4_url,
              imp_btn5_text: data.data.imp_btn5_text,
              imp_btn5_url: data.data.imp_btn5_url,
              imp_btn6_text: data.data.imp_btn6_text,
              imp_btn6_url: data.data.imp_btn6_url,
              title8: data.data.title8,
              title8_desc: data.data.title8_desc,
              imp_btn7_text: data.data.imp_btn7_text,
              imp_btn7_url: data.data.imp_btn7_url,
              seohidden: data.data.seohidden
            });
          }
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    });

    this.http.get<any>(this.api_endpoint + '/courses/').subscribe(
      data => {
        this.courses = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });

    this.feesForm = this.formBuilder.group({
      slider_title: [''],
      courseId: ['', Validators.required],
      /* duration: ['', [Validators.required,Validators.min(1),Validators.max(4)]], */
      coursename: [''],
      slider_desc: [''],
      slider_img: [''],
      slider_alt_image: [''],
      brouhure_url: [''],
      apply_url: [''],
      title1: [''],
      title1_desc: [''],
      title2: [''],
      title2_img1: [''],
      title2_img1_alt: [''],
      title2_img2: [''],
      title2_img2_alt: [''],
      title2_img3: [''],
      title2_img3_alt: [''],
      skill1: [''],
      skill1_desc: [''],
      skill2: [''],
      skill2_desc: [''],
      skill3: [''],
      skill3_desc: [''],
      imp_btn1_text: [''],
      imp_btn1_url: [''],
      title3: [''],
      title3_desc: [''],
      title3_img1: [''],
      title3_img1_alt: [''],
      title3_img2: [''],
      title3_img2_alt: [''],
      title3_img3: [''],
      title3_img3_alt: [''],
      skill4: [''],
      skill4_desc: [''],
      skill5: [''],
      skill5_desc: [''],
      skill6: [''],
      skill6_desc: [''],
      imp_btn2_text: [''],
      imp_btn2_url: [''],
      title4: [''],
      count1: [''],
      count1_desc: [''],
      count1_title: [''],
      count1_keys: [''],
      count2: [''],
      count2_desc: [''],
      count2_title: [''],
      count2_keys: [''],
      title5: [''],
      title5_desc: [''],
      title5_img1: [''],
      title5_img1_alt: [''],
      title5_img2: [''],
      title5_img2_alt: [''],
      title5_img3: [''],
      title5_img3_alt: [''],
      skill7: [''],
      skill7_desc: [''],
      skill8: [''],
      skill8_desc: [''],
      skill9: [''],
      skill9_desc: [''],
      imp_btn3_text: [''],
      imp_btn3_url: [''],
      title6: [''],
      skill10: [''],
      skill10_desc: [''],
      skill10_keys: [''],
      skill11: [''],
      skill11_desc: [''],
      skill11_keys: [''],
      skill12: [''],
      skill12_desc: [''],
      skill12_keys: [''],
      title7: [''],
      title7_img1: [''],
      title7_img1_alt: [''],
      title7_img2: [''],
      title7_img2_alt: [''],
      title7_img3: [''],
      title7_img3_alt: [''],
      skill13: [''],
      skill13_desc: [''],
      skill14: [''],
      skill14_desc: [''],
      skill15: [''],
      skill15_desc: [''],
      imp_btn4_text: [''],
      imp_btn4_url: [''],
      imp_btn5_text: [''],
      imp_btn5_url: [''],
      imp_btn6_text: [''],
      imp_btn6_url: [''],
      title8: [''],
      title8_desc: [''],
      imp_btn7_text: [''],
      imp_btn7_url: [''],
      seohidden: [''],
      _id: ['']
    })
  }

  get f() { return this.feesForm.controls; }

  getcourses(value) {
    this.http.get<any>(this.api_endpoint + '/coursebyid/' + value).subscribe(
      data => {

        this.feesForm.patchValue({
          coursename: data.data.course,
        })

      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }

  onFormSubmit() {

    this.submitted = true;

    if (this.feesForm.invalid) {
      return;
    }


    // console.log(this.coursename);
    if (this.action == 'Submit') {



      var data = {
        "courseId": this.feesForm.value.courseId,
        "slider_title": this.feesForm.value.slider_title,
        "coursename": this.feesForm.value.coursename,
        "slider_desc": this.feesForm.value.slider_desc,
        "slider_img": this.feesForm.value.slider_img,
        "slider_alt_image": this.feesForm.value.slider_alt_image,
        "brouhure_url": this.feesForm.value.brouhure_url,
        "apply_url": this.feesForm.value.apply_url,
        "title1": this.feesForm.value.title1,
        "title1_desc": this.feesForm.value.title1_desc,
        "title2": this.feesForm.value.title2,
        "title2_desc": this.feesForm.value.title2_desc,
        "title2_img1": this.feesForm.value.title2_img1,
        "title2_img1_alt": this.feesForm.value.title2_img1_alt,
        "title2_img2": this.feesForm.value.title2_img2,
        "title2_img2_alt": this.feesForm.value.title2_img2_alt,
        "title2_img3": this.feesForm.value.title2_img3,
        "title2_img3_alt": this.feesForm.value.title2_img3_alt,
        "skill1": this.feesForm.value.skill1,
        "skill1_desc": this.feesForm.value.skill1_desc,
        "skill2": this.feesForm.value.skill2,
        "skill2_desc": this.feesForm.value.skill2_desc,
        "skill3": this.feesForm.value.skill3,
        "skill3_desc": this.feesForm.value.skill3_desc,
        "imp_btn1_text": this.feesForm.value.imp_btn1_text,
        "imp_btn1_url": this.feesForm.value.imp_btn1_url,
        "title3": this.feesForm.value.title3,
        "title3_desc": this.feesForm.value.title3_desc,
        "title3_img1": this.feesForm.value.title3_img1,
        "title3_img1_alt": this.feesForm.value.title3_img1_alt,
        "title3_img2": this.feesForm.value.title3_img2,
        "title3_img2_alt": this.feesForm.value.title3_img2_alt,
        "title3_img3": this.feesForm.value.title3_img3,
        "title3_img3_alt": this.feesForm.value.title3_img3_alt,
        "skill4": this.feesForm.value.skill4,
        "skill4_desc": this.feesForm.value.skill4_desc,
        "skill5": this.feesForm.value.skill5,
        "skill5_desc": this.feesForm.value.skill5_desc,
        "skill6": this.feesForm.value.skill6,
        "skill6_desc": this.feesForm.value.skill6_desc,
        "imp_btn2_text": this.feesForm.value.imp_btn2_text,
        "imp_btn2_url": this.feesForm.value.imp_btn2_url,
        "title4": this.feesForm.value.title4,
        "count1": this.feesForm.value.count1,
        "count1_desc": this.feesForm.value.count1_desc,
        "count1_title": this.feesForm.value.count1_title,
        "count1_keys": this.feesForm.value.count1_keys,
        "count2": this.feesForm.value.count2,
        "count2_desc": this.feesForm.value.count2_desc,
        "count2_title": this.feesForm.value.count2_title,
        "count2_keys": this.feesForm.value.count2_keys,
        "title5": this.feesForm.value.title5,
        "title5_desc": this.feesForm.value.title5_desc,
        "title5_img1": this.feesForm.value.title5_img1,
        "title5_img1_alt": this.feesForm.value.title5_img1_alt,
        "title5_img2": this.feesForm.value.title5_img2,
        "title5_img2_alt": this.feesForm.value.title5_img2_alt,
        "title5_img3": this.feesForm.value.title5_img3,
        "title5_img3_alt": this.feesForm.value.title5_img3_alt,
        "skill7": this.feesForm.value.skill7,
        "skill7_desc": this.feesForm.value.skill7_desc,
        "skill8": this.feesForm.value.skill8,
        "skill8_desc": this.feesForm.value.skill8_desc,
        "skill9": this.feesForm.value.skill9,
        "skill9_desc": this.feesForm.value.skill9_desc,
        "imp_btn3_text": this.feesForm.value.imp_btn3_text,
        "imp_btn3_url": this.feesForm.value.imp_btn3_url,
        "title6": this.feesForm.value.title6,
        "skill10": this.feesForm.value.skill10,
        "skill10_desc": this.feesForm.value.skill10_desc,
        "skill10_keys": this.feesForm.value.skill10_keys,
        "skill11": this.feesForm.value.skill11,
        "skill11_desc": this.feesForm.value.skill11_desc,
        "skill11_keys": this.feesForm.value.skill11_keys,
        "skill12": this.feesForm.value.skill12,
        "skill12_desc": this.feesForm.value.skill12_desc,
        "skill12_keys": this.feesForm.value.skill12_keys,
        "title7": this.feesForm.value.title7,
        "title7_img1": this.feesForm.value.title7_img1,
        "title7_img1_alt": this.feesForm.value.title7_img1_alt,
        "title7_img2": this.feesForm.value.title7_img2,
        "title7_img2_alt": this.feesForm.value.title7_img2_alt,
        "title7_img3": this.feesForm.value.title7_img3,
        "title7_img3_alt": this.feesForm.value.title7_img3_alt,
        "skill13": this.feesForm.value.skill13,
        "skill13_desc": this.feesForm.value.skill13_desc,
        "skill14": this.feesForm.value.skill14,
        "skill14_desc": this.feesForm.value.skill14_desc,
        "skill15": this.feesForm.value.skill15,
        "skill15_desc": this.feesForm.value.skill15_desc,
        "imp_btn4_text": this.feesForm.value.imp_btn4_text,
        "imp_btn4_url": this.feesForm.value.imp_btn4_url,
        "imp_btn5_text": this.feesForm.value.imp_btn5_text,
        "imp_btn5_url": this.feesForm.value.imp_btn5_url,
        "imp_btn6_text": this.feesForm.value.imp_btn6_text,
        "imp_btn6_url": this.feesForm.value.imp_btn6_url,
        "title8": this.feesForm.value.title8,
        "title8_desc": this.feesForm.value.title8_desc,
        "imp_btn7_text": this.feesForm.value.imp_btn7_text,
        "imp_btn7_url": this.feesForm.value.imp_btn7_url,
        "admin": sessionStorage.getItem('adminName'),
        "seohidden": this.feesForm.value.seohidden,
      };
      console.log(data);

      this.http.post<any>(this.api_endpoint + '/beyond', data).subscribe(
        res => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          } else {
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          }
          this.router.navigateByUrl('/adminhkbkcms/beyond/list-page');
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured." + err);
          }
        });
    } else {
      var data1 = {
        "courseId": this.feesForm.value.courseId,
        "slider_title": this.feesForm.value.slider_title,
        "coursename": this.feesForm.value.coursename,
        "slider_desc": this.feesForm.value.slider_desc,
        "slider_img": this.feesForm.value.slider_img,
        "slider_alt_image": this.feesForm.value.slider_alt_image,
        "brouhure_url": this.feesForm.value.brouhure_url,
        "apply_url": this.feesForm.value.apply_url,
        "title1": this.feesForm.value.title1,
        "title1_desc": this.feesForm.value.title1_desc,
        "title2": this.feesForm.value.title2,
        "title2_desc": this.feesForm.value.title2_desc,
        "title2_img1": this.feesForm.value.title2_img1,
        "title2_img1_alt": this.feesForm.value.title2_img1_alt,
        "title2_img2": this.feesForm.value.title2_img2,
        "title2_img2_alt": this.feesForm.value.title2_img2_alt,
        "title2_img3": this.feesForm.value.title2_img3,
        "title2_img3_alt": this.feesForm.value.title2_img3_alt,
        "skill1": this.feesForm.value.skill1,
        "skill1_desc": this.feesForm.value.skill1_desc,
        "skill2": this.feesForm.value.skill2,
        "skill2_desc": this.feesForm.value.skill2_desc,
        "skill3": this.feesForm.value.skill3,
        "skill3_desc": this.feesForm.value.skill3_desc,
        "imp_btn1_text": this.feesForm.value.imp_btn1_text,
        "imp_btn1_url": this.feesForm.value.imp_btn1_url,
        "title3": this.feesForm.value.title3,
        "title3_desc": this.feesForm.value.title3_desc,
        "title3_img1": this.feesForm.value.title3_img1,
        "title3_img1_alt": this.feesForm.value.title3_img1_alt,
        "title3_img2": this.feesForm.value.title3_img2,
        "title3_img2_alt": this.feesForm.value.title3_img2_alt,
        "title3_img3": this.feesForm.value.title3_img3,
        "title3_img3_alt": this.feesForm.value.title3_img3_alt,
        "skill4": this.feesForm.value.skill4,
        "skill4_desc": this.feesForm.value.skill4_desc,
        "skill5": this.feesForm.value.skill5,
        "skill5_desc": this.feesForm.value.skill5_desc,
        "skill6": this.feesForm.value.skill6,
        "skill6_desc": this.feesForm.value.skill6_desc,
        "imp_btn2_text": this.feesForm.value.imp_btn2_text,
        "imp_btn2_url": this.feesForm.value.imp_btn2_url,
        "title4": this.feesForm.value.title4,
        "count1": this.feesForm.value.count1,
        "count1_desc": this.feesForm.value.count1_desc,
        "count1_title": this.feesForm.value.count1_title,
        "count1_keys": this.feesForm.value.count1_keys,
        "count2": this.feesForm.value.count2,
        "count2_desc": this.feesForm.value.count2_desc,
        "count2_title": this.feesForm.value.count2_title,
        "count2_keys": this.feesForm.value.count2_keys,
        "title5": this.feesForm.value.title5,
        "title5_desc": this.feesForm.value.title5_desc,
        "title5_img1": this.feesForm.value.title5_img1,
        "title5_img1_alt": this.feesForm.value.title5_img1_alt,
        "title5_img2": this.feesForm.value.title5_img2,
        "title5_img2_alt": this.feesForm.value.title5_img2_alt,
        "title5_img3": this.feesForm.value.title5_img3,
        "title5_img3_alt": this.feesForm.value.title5_img3_alt,
        "skill7": this.feesForm.value.skill7,
        "skill7_desc": this.feesForm.value.skill7_desc,
        "skill8": this.feesForm.value.skill8,
        "skill8_desc": this.feesForm.value.skill8_desc,
        "skill9": this.feesForm.value.skill9,
        "skill9_desc": this.feesForm.value.skill9_desc,
        "imp_btn3_text": this.feesForm.value.imp_btn3_text,
        "imp_btn3_url": this.feesForm.value.imp_btn3_url,
        "title6": this.feesForm.value.title6,
        "skill10": this.feesForm.value.skill10,
        "skill10_desc": this.feesForm.value.skill10_desc,
        "skill10_keys": this.feesForm.value.skill10_keys,
        "skill11": this.feesForm.value.skill11,
        "skill11_desc": this.feesForm.value.skill11_desc,
        "skill11_keys": this.feesForm.value.skill11_keys,
        "skill12": this.feesForm.value.skill12,
        "skill12_desc": this.feesForm.value.skill12_desc,
        "skill12_keys": this.feesForm.value.skill12_keys,
        "title7": this.feesForm.value.title7,
        "title7_img1": this.feesForm.value.title7_img1,
        "title7_img1_alt": this.feesForm.value.title7_img1_alt,
        "title7_img2": this.feesForm.value.title7_img2,
        "title7_img2_alt": this.feesForm.value.title7_img2_alt,
        "title7_img3": this.feesForm.value.title7_img3,
        "title7_img3_alt": this.feesForm.value.title7_img3_alt,
        "skill13": this.feesForm.value.skill13,
        "skill13_desc": this.feesForm.value.skill13_desc,
        "skill14": this.feesForm.value.skill14,
        "skill14_desc": this.feesForm.value.skill14_desc,
        "skill15": this.feesForm.value.skill15,
        "skill15_desc": this.feesForm.value.skill15_desc,
        "imp_btn4_text": this.feesForm.value.imp_btn4_text,
        "imp_btn4_url": this.feesForm.value.imp_btn4_url,
        "imp_btn5_text": this.feesForm.value.imp_btn5_text,
        "imp_btn5_url": this.feesForm.value.imp_btn5_url,
        "imp_btn6_text": this.feesForm.value.imp_btn6_text,
        "imp_btn6_url": this.feesForm.value.imp_btn6_url,
        "title8": this.feesForm.value.title8,
        "title8_desc": this.feesForm.value.title8_desc,
        "imp_btn7_text": this.feesForm.value.imp_btn7_text,
        "imp_btn7_url": this.feesForm.value.imp_btn7_url,
        "admin": sessionStorage.getItem('adminName'),
        "seohidden": this.feesForm.value.seohidden,
        "_id": this.feesForm.value._id,
      };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint + '/beyond/' + data1._id, data1).subscribe(
        res => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          } else {
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          }
          this.router.navigateByUrl('/adminhkbkcms/beyond/list-page');
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    }
  }

}
